import { UserPermissions } from '../../../components/User';
import { UserType } from '../../../types';

export function VendorUserPermissions() {
  return <UserPermissions type={UserType.Vendor} />;
}
